import { Accordion } from '@/components/common/Accordion';
import { CardsContainer } from '@/components/dashboard/DashboardCard';
import { Settings } from '@/components/dashboard/statistics/Settings';
import { StatisticsDoctors } from '@/components/dashboard/statistics/StatisticsDoctors';
import { StatisticsSupplements } from '@/components/dashboard/statistics/StatisticsSupplements';
import { cn } from '@/lib/cn';
import { useBreakpoint } from '@/lib/contexts/BreakpointContext';
import { useState } from 'react';

export const StatisticsPage = () => {
  const { isDesktop, isBigDesktop } = useBreakpoint();
  const [accordionValue, setAccordionValue] = useState('');

  return (
    <div className="px-0 py-12.5 md:px-4">
      <CardsContainer
        className={cn(
          'md:rounded-0 pt-8 lg:max-w-305 lg:rounded-3xl xl:w-full',
          isBigDesktop ? 'mx-auto' : isDesktop ? 'mx-2' : 'mx-0',
        )}
      >
        <Accordion
          type="single"
          collapsible
          className="w-full space-y-4 border-none"
          value={accordionValue}
          onValueChange={setAccordionValue}
        >
          <StatisticsDoctors accordionOpenValue={accordionValue} />
          <StatisticsSupplements accordionOpenValue={accordionValue} />
          <Settings />
        </Accordion>
      </CardsContainer>
    </div>
  );
};
